<span [style.--primary_btn_text_colour]="this.dataStore.primary_btn_text_colour"
    [style.--primary_btn_back_colour]="this.dataStore.primary_btn_back_colour"
    [style.--primary_btn_back_colour_hover]="this.dataStore.primary_btn_back_colour_hover"
    [style.--primary_btn_text_colour_hover]="this.dataStore.primary_btn_text_colour_hover"
    [style.--secondary_btn_text_colour]="this.dataStore.secondary_btn_text_colour"
    [style.--secondary_btn_back_colour]="this.dataStore.secondary_btn_back_colour"
    [style.--secondary_btn_back_colour_hover]="this.dataStore.secondary_btn_back_colour_hover"
    [style.--secondary_btn_text_colour_hover]="this.dataStore.secondary_btn_text_colour_hover">
    <ng-container *ngIf="formFields.length > 0">
        <ng-container *ngFor="let child of children; index as idx">
            <form [formGroup]="childForms[idx]" *ngIf="formFields[idx] && formFields[idx].length > 0">
                <ng-container *ngFor="let field of formFields[idx]">
                    <div [ngClass]="{'govuk-form-group': true, 'govuk-form-group--error': !childForms[idx].pristine  
                        && ((childForms[idx].get(field.field)?.touched && childForms[idx].get(field.field)?.status === 'INVALID') 
                        || childForms[idx].get(field.field  + 'd')?.errors?.error)}">
                        <ng-container *ngIf="formService.shouldShowConditional(formId, field, idx)">
                            <ng-container
                                *ngIf="field.type !== 'checkbox' && field.type !== 'radio' && field.type !== 'dropdown' && field.type !== 'heading' && field.type !== 'submit'">
                                <p class="govuk-label-wrapper">
                                    <label class="govuk-label govuk-label--s" for="field.field">
                                        {{ field.title }}
                                        <ng-container *ngIf="field.required">
                                            *
                                        </ng-container>
                                    </label>
                                </p>
                                <ng-container *ngIf="field.helptext">
                                    <div id="{{field.field}}-hint" class="govuk-hint" [innerHTML]="field.helptext">
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="field.type == 'text'">
                                    <input id="field.field" type="text" formControlName="{{field.field}}"
                                        [ngClass]="{'govuk-input': true, 'govuk-input--error': !childForms[idx].pristine && childForms[idx].get(field.field)?.touched && childForms[idx].get(field.field)?.errors }">
                                </ng-container>
                                <ng-container *ngIf="field.type == 'date'">
                                    <!-- <input id="field.field" type="date" formControlName="{{field.field}}" -->
                                    <!-- [ngClass]="{'govuk-input': true, 'govuk-input--error': !childForms[idx].pristine && childForms[idx].get(field.field)?.touched && childForms[idx].get(field.field)?.errors }"> -->
                                    <div class="govuk-form-group govuk-form-group">
                                        <fieldset class="govuk-fieldset" role="group"
                                            aria-describedby="passport-issued-hint">
                                            <div class="govuk-date-input" id="passport-issued">
                                                <div class="govuk-date-input__item">
                                                    <div class="govuk-form-group govuk-form-group">
                                                        <label class="govuk-label govuk-date-input__label"
                                                            for="passport-issued-day">
                                                            <span class="fonter"> Day</span>
                                                        </label>
                                                        <input (change)="onDateChange(field.field,childForms[idx])"
                                                            class="govuk-input govuk-date-input__input govuk-input--width-3 form-control govuk-input"
                                                            type="text" inputmode="numeric"
                                                            formControlName="{{field.field + 'd'}}"
                                                            attr.aria-label="{{field.title + 'day'}} input field"
                                                            maxlength="2">
                                                    </div>
                                                </div>
                                                <div class="govuk-date-input__item">
                                                    <div class="govuk-form-group govuk-form-group">
                                                        <label class="govuk-label govuk-date-input__label"
                                                            for="passport-issued-month">
                                                            <span class="fonter"> Month </span>
                                                        </label>
                                                        <input (change)="onDateChange(field.field,childForms[idx])"
                                                            class="govuk-input govuk-date-input__input govuk-input--width-3 form-control govuk-input"
                                                            type="text" inputmode="numeric"
                                                            formControlName="{{field.field + 'm'}}"
                                                            attr.aria-label="{{field.title + 'month'}} input field"
                                                            maxlength="2">
                                                    </div>
                                                </div>
                                                <div class="govuk-date-input__item">
                                                    <div class="govuk-form-group govuk-form-group">
                                                        <label class="govuk-label govuk-date-input__label"
                                                            for="passport-issued-year">
                                                            <span class="fonter"> Year </span>
                                                        </label>
                                                        <input (change)="onDateChange(field.field,childForms[idx])"
                                                            class="govuk-input govuk-date-input__input govuk-input--width-3 form-control govuk-input"
                                                            type="text" inputmode="numeric"
                                                            formControlName="{{field.field + 'y'}}"
                                                            attr.aria-label="{{field.title + 'year'}} input field"
                                                            maxlength="4">
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="field.type == 'number'">
                                    <input id="field.field" type="number" formControlName="{{field.field}}"
                                        [ngClass]="{'govuk-input': true, 'govuk-input--error': !childForms[idx].pristine && childForms[idx].get(field.field)?.touched && childForms[idx].get(field.field)?.errors }">
                                </ng-container>

                                <ng-container *ngIf="field.type == 'email'">
                                    <input id="field.field" type="email" formControlName="{{field.field}}"
                                        [ngClass]="{'govuk-input': true, 'govuk-input--error': !childForms[idx].pristine && childForms[idx].get(field.field)?.touched && childForms[idx].get(field.field)?.errors }">
                                </ng-container>

                                <ng-container *ngIf="field.type == 'textarea'">
                                    <textarea id="field.field" formControlName="{{field.field}}"
                                        [ngClass]="{'govuk-textarea': true, 'govuk-textarea--error': !childForms[idx].pristine && childForms[idx].get(field.field)?.touched && childForms[idx].get(field.field)?.errors }"></textarea>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="field.type == 'checkbox'">
                                <ng-container *ngIf="formService.shouldShowConditional(formId, field, idx)">
                                    <div class="govuk-form-group">
                                        <fieldset class="govuk-fieldset" aria-describedby="field.name+'-hint'">
                                            <ng-container *ngIf="field.helptext">
                                                <div id="{{field.field}}-hint" class="govuk-hint"
                                                    [innerHTML]="field.helptext">
                                                </div>
                                            </ng-container>
                                            <div class="govuk-checkboxes" data-module="govuk-checkboxes">
                                                <div class="govuk-checkboxes__item">
                                                    <input class="govuk-checkboxes__input" 
                                                        id="{{formService.getParentField(formId,field).field}}-{{field.field}}"
                                                        type="checkbox" formControlName="{{field.field}}"
                                                        [attr.checked]="field.value ? field.value : null">
                                                    <label
                                                        class="govuk-label govuk-checkboxes__label govuk-label--s"
                                                        for="{{field.field}}">
                                                        {{field.title}}
                                                        <ng-container *ngIf="field.required">
                                                            *
                                                        </ng-container>
                                                    </label>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="field.type == 'radio'">
                                <ng-container *ngIf="formService.shouldShowConditional(formId, field, idx)">
                                    <div class="govuk-form-group">
                                        <fieldset class="govuk-fieldset">
                                            <legend class="govuk-fieldset__legend govuk-fieldset__legend--s">
                                                <p class="govuk-fieldset__heading">
                                                    {{ field.title}}
                                                    <ng-container *ngIf="field.required">
                                                        *
                                                    </ng-container>
                                                </p>
                                            </legend>
                                            <ng-container *ngIf="field.helptext">
                                                <div id="{{field.field}}-hint" class="govuk-hint"
                                                    [innerHTML]="field.helptext">
                                                </div>
                                            </ng-container>
                                            <ng-container *ngIf="!field.hasOwnProperty('radio_options')">
                                                <div class="govuk-radios" data-module="govuk-radios">
                                                    <div class="govuk-radios__item">
                                                        <input class="govuk-radios__input" id="{{field.field}}"
                                                            type="radio" value="true"
                                                            formControlName="{{field.field}}"
                                                            [attr.checked]="field.value ? field.value : null">
                                                        <label class="govuk-label govuk-radios__label"
                                                            for="field.field">
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div class="govuk-radios__item">
                                                        <input class="govuk-radios__input" id="{{field.field}}"
                                                            type="radio" value="false"
                                                            formControlName="{{field.field}}"
                                                            [attr.checked]="field.value ? field.value : null">
                                                        <label class="govuk-label govuk-radios__label"
                                                            for="field.field">
                                                            No
                                                        </label>
                                                    </div>

                                                </div>
                                            </ng-container>
                                            <ng-container *ngIf="field.hasOwnProperty('radio_options')">
                                                <div class="govuk-radios" data-module="govuk-radios">
                                                    <div class="govuk-radios__item"
                                                        *ngFor="let radio of field.radio_options;; index as idx">
                                                        <input class="govuk-radios__input"
                                                            id="{{field.field}}-${{idx}}" type="radio"
                                                            value="{{ radio.value }}"
                                                            formControlName="{{field.field}}"
                                                            [attr.checked]="field.value ? field.value : null">
                                                        <label class="govuk-label govuk-radios__label"
                                                            for="field.field" [innerHTML]="radio.title">
                                                        </label>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </fieldset>
                                    </div>
                                </ng-container>

                            </ng-container>
                            <ng-container *ngIf="field.type == 'dropdown'">
                                <p class="govuk-label-wrapper">
                                    <label class="govuk-label govuk-label--s" for="field.field">
                                        {{ field.title }}
                                        <ng-container *ngIf="field.required">
                                            *
                                        </ng-container>
                                    </label>
                                </p>
                                <ng-container *ngIf="field.helptext">
                                    <div id="{{field.field}}-hint" class="govuk-hint" [innerHTML]="field.helptext">
                                    </div>
                                </ng-container>
                                <select class="govuk-select" id="{{field.field}}" formControlName="{{field.field}}">
                                    <option value="">Please select</option>
                                    <ng-container *ngFor="let opt of field.options">
                                        <option *ngIf="opt.visible" value="{{opt.value}}">{{opt.title}}</option>
                                    </ng-container>
                                </select>
                            </ng-container>
                            <ng-container *ngIf="field.type == 'upload'">
                                <input class="govuk-file-upload" id="file-upload-1" name="fileUpload1" type="file" multiple (change)="uploadTest(idx, field, $event)" [accept]="field.filetypes.join(',')">
                                <ng-container *ngIf="childForms[idx].get(field.field).controls && childForms[idx].get(field.field).controls.length > 0">
                                    <table class="govuk-table">
                                        <caption class="govuk-table__caption govuk-table__caption--m">File information</caption>
                                        <thead class="govuk-table__head">
                                          <tr class="govuk-table__row">
                                            <th scope="col" class="govuk-table__header">Name</th>
                                            <th scope="col" class="govuk-table__header">Size</th>
                                            <th scope="col" class="govuk-table__header">&nbsp;</th>
                                          </tr>
                                        </thead>
                                        <tbody class="govuk-table__body">
                                          <tr class="govuk-table__row" *ngFor="let file of childForms[idx].get(field.field).controls; index as i">
                                            <td class="govuk-table__cell">{{ file.controls.file.value.name }}</td>
                                            <td class="govuk-table__cell">{{ (file.controls.file.value.size / (1024 * 1024)).toFixed(3) }}MB</td>
                                            <td class="govuk-table__cell"><a class="govuk-link" (click)="removeFileAtIndex(i, field, idx, $event)" href="#">Remove<span class="govuk-visually-hidden">file</span></a></td>
                                          </tr>
                                        </tbody>
                                    </table>
                                </ng-container>

                            </ng-container>
                            <ng-container *ngIf="field.type == 'heading'">
                                <div>
                                    <h2 class="govuk-heading-s" [innerHTML]="field.title"></h2>
                                </div>
                                <ng-container *ngIf="field.helptext">
                                    <div id="{{field.field}}-hint" class="govuk-hint" [innerHTML]="field.helptext">
                                    </div>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="field.type == 'submit'">
                                <ng-container *ngIf="field.helptext">
                                    <div id="{{field.field}}-hint" class="govuk-hint" [innerHTML]="field.helptext">
                                    </div>
                                </ng-container>
                                <div *ngIf="showSubmit">
                                    <button data-prevent-double-click="true" class="govuk-button"
                                        data-module="govuk-button" (click)="submit(formId)">
                                        {{field.title}}
                                    </button>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="field.type == 'button'">
                                <ng-container *ngIf="field.helptext">
                                    <div id="{{field.field}}-hint" class="govuk-hint" [innerHTML]="field.helptext">
                                    </div>
                                </ng-container>
                                <div>
                                    <button data-prevent-double-click="true" class="govuk-button"
                                        data-module="govuk-button govuk-button--secondary">
                                        {{field.title}}
                                    </button>
                                </div>
                            </ng-container>
                            <ng-container
                                *ngIf="!childForms[idx].pristine && childForms[idx].get(field.field)?.touched && childForms[idx].get(field.field)?.errors">
                                <p *ngIf="childForms[idx].get(field.field)?.errors.required"
                                    class="govuk-error-message">
                                    <span class="govuk-visually-hidden">Error:</span> {{ field.title }} is mandatory
                                </p>
                            </ng-container>
                        </ng-container>
                    </div>
                </ng-container>
            </form>
        </ng-container>
    </ng-container>
</span>